import { inject, observer } from "mobx-react";
import MembersComponent from "../../components/UserManagement/Members/MembersComponent.jsx";

const Members = inject('userStore','sharedStore')(observer(MembersComponent));

export default Members;